// Module
var code = ` <div class="filters">

    <!-- Branch -->
    <div class="labelled-field labelled-field--long">
      <label for="filter-branch" class="add-on">Branch</label>
      <select id="filter-branch"
              class="form-control"
              ng-disabled="\$ctrl.availableBranches && \$ctrl.availableBranches.length === 1"
              ng-model="\$ctrl.filter.branchId"
              ng-options="branch.id as branch.name for branch in \$ctrl.availableBranches">
        <option value="" ng-if="\$ctrl.availableBranches && \$ctrl.availableBranches.length > 1">(All branches)</option>
      </select>

    </div>

    <!-- Actions -->
    <button ng-click="\$ctrl.showBranchStopOrders()" class="btn btn-primary btn--filter">
      Filter
    </button>

  </div>


  <div class="tab-content">
    <div class="tab-pane" id="tab-active-stop-orders" ng-class="{'active': true}">
      <div ng-if="\$ctrl.stopOrders && \$ctrl.stopOrders.length > 0">
        <table class="table table--last-column-to-right" ng-table="\$ctrl.tableConfig">
          <tbody class="appraisal-details">
          <tr ng-repeat="item in \$ctrl.stopOrders"
              ng-click="\$ctrl.itemClicked(item, \$event)"
              ng-class="{'selected': \$ctrl.selectedCheckId === item.id}">
            <td data-title="'Id'">{{item.id}}</td>
            <td data-title="'Check number'">{{item.checkNumber}}</td>
            <td data-title="'Branch'">{{item.branchName}}</td>
            <td data-title="'Product number'">{{item.productNumber}}</td>
            <td data-title="'Customer name'">{{item.effectiveCustomerName}}</td>
            <td data-title="'Created on'">{{item.createdOn | prettyDateTime}}</td>
            <td data-title="'Created by'">{{item.createdByFullName}}</td>
            <td data-title="'Remarks'">{{item.remarks}}</td>
            <td data-title="'Actions'" class="table__actions">
              <button class="btn btn-danger"
                      command-access="RemoveCheckStopOrder"
                      ng-click="\$ctrl.remove(item.id)">Remove</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div ng-if="\$ctrl.stopOrders == null || \$ctrl.stopOrders.length === 0" class="empty-message">
    <span>No stop orders matching given criteria found</span>
  </div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/stop-order/active/active-stop-order-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;